





























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";
import { getTimeAgo, getBirthday } from "@/services/dateTime/date-time-fofmat";

import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    btns: ChangeDeliteButtons,
  },
})
export default class StandartUserModal extends Vue {
  @Prop({ type: Object, default: null }) user!: IUser;
  @Prop({ type: Boolean, default: false }) canChange!: boolean;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: String, default: "tv" }) deviceType!: string;

  getBirthday(date: string | Date): string {
    if (!date) return "";
    return getBirthday(date);
  }

  getDateTime(date: string | Date): string {
    return getTimeAgo(date);
  }

  async confirmDelete(): Promise<void> {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      String(this.$i18n.t("main.confirms.delete")),
      {
        title: String(this.$i18n.t("main.confirms.ok")),
      }
    );
    if (confirmed === true) {
      this.$emit("deletedUser", this.user._id);
    }
  }
}
